import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";

require('./bringoz-package-item-icon.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-package-item-icon',
  templateUrl: './bringoz-package-item-icon.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozPackageItemIconComponent implements OnInit, OnChanges {
  @Input() isPacked: any;
  @Input() id: string;
  @Input() icon: string;
  @Input() name: string;
  @Input() packingDisplayStatus: string;
  @Input() isMissingPackage: boolean;

  private sitePackageItemsMap: any;
  public iconFill: string;
  public iconStatusColor: object;

  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.iconStatusColor = {
      InProcess: '#317AD5',
      NotPacked: '#7E7E7E',
      Packed: '#3FA300'
    }
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
    this.initPackageItemIcon();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.initPackageItemIcon();
    }
  }

  private initPackageItemIcon() {
    this.icon = this.id ? this.sitePackageItemsMap[this.id].icon : this.icon;
    this.name = this.id ? this.sitePackageItemsMap[this.id].name : this.name;

    if (this.isMissingPackage) {
      this.iconFill = '#F56565';
    } else {
      this.iconFill = this.iconStatusColor[this.packingDisplayStatus];
    }
  }

}
